import { FunctionComponent } from 'react';
import {Button, Form, Image} from 'react-bootstrap';
import styles from "./SearchInput.module.css";
import cn from 'classnames';
import { ASSESTS } from '../../../constant/assest';

interface ISearchInputProps {
    placeholder?: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
};

const SearchInput: FunctionComponent<ISearchInputProps> = ({placeholder, value, onChange, className}) => {
    return (
        <div className={cn(styles.searchInputWrap, className)}>
            <Form.Group className={styles.searchInputContainer}>
                <Button bsPrefix={styles.searcBtn}>
                    <Image src={ASSESTS.SEARCHICON} alt='Search' />
                </Button>
                <Form.Control                 
                    type="text" 
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    className={styles.searcInput}
                />
                <Button bsPrefix={styles.settingBtn}>
                    <Image src={ASSESTS.SETTINGICON} alt='Setting' />
                </Button>
            </Form.Group>
        </div>
    );
};

export default SearchInput;
